
<template>
  <div style="font-family: 'Roboto Slab', serif">
    <div v-if="Request == null || Request == '' || Request == undefined">
      <center class="loading-medium">
        <loading></loading>
      </center>
    </div>
    <div
      v-if="Request"
      style="
        width: 800px;
        height: 1270px;
        border: 1px solid black;
        margin: auto;
        padding: 20px;
        font-size: 14px;
      "
    >
      <div style>
        <div class="col-xs-3">
          <img
            src="../../assets/imgs/png/FAJRLOGO01.png"
            style="float: left; height: 90px; width: 130px"
          />
        </div>
        <div class="col-xs-6">
          <h3
            style="
              font-weight: 500;
              margin-top: 60px;
              font-size: 28px;
              font-family: 'Roboto Slab', serif;
            "
          >
            CONFIRMATION OF SALE
          </h3>
        </div>
        <div class="col-xs-3">
          <img
            src="../../assets/imgs/arabic-logo.jpg"
            style="float: right; height: 90px; width: 130px"
          />
        </div>
      </div>
      <br clear="all" />
      <!-- <h2
      style="text-align:center;padding-bottom:0;border-top:solid 1px #000;margin-bottom:2px;padding-bottom:5px;padding-top:5px;border-bottom:solid 1px #000;"
      >SELLER'S OFFER</h2>-->

      <!-- <div style="padding-top:0;margin-top:0;height:1px;border-top:solid 1px #000;margin-top:1px"></div> -->
      <hr style="border: 1.2px solid #b35900" />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">To:</div>
          <div class="col-xs-6">
            {{ Request.BankName }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-2" style="font-weight: bold">Date:</div>
          <div class="col-xs-6">
            {{ DateFromat(Request.ApplicationDate, true) }}
          </div>
        </div>
      </div>

      <hr style="border: 1px solid #b35900; margin-top: 5px" />

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-6" style="font-weight: bold">
            Transaction Reference Number:
          </div>
          <div class="col-xs-6">
            {{ Request.RefNo }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-6" style="font-weight: bold">Your Reference:</div>
          <div class="col-xs-6">
            {{ Request.BankReference }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-6" style="font-weight: bold">As Agent For:</div>
          <div class="col-xs-6">
            {{
              Request.ClientName == null || Request.ClientName == ""
                ? "N/A"
                : Request.ClientName
            }}
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              Dear Sirs,
              <br />
              <br />
              The purpose of this confirmation ("Confirmation") is to confirm
              the terms and conditions of the transaction entered between us by
              telephone/electronic platform on the Contract Date specified below
              (the "Transaction"). This Confirmation is expressly subject to the
              terms of the Master Sale Agreement entered into between us on
              {{ AggrementDate }}. We hereby confirm the sale of the Commodity
              (as defined below) by us to you as follows:
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="row" style="margin-top: -15px">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Commodity:</div>
          <div class="col-xs-7">{{ Request.CommodityName }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Description:
          </div>
          <div class="col-xs-7">99.95% pt - 'Good Delivery'</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Certificate Number:
          </div>
          <div class="col-xs-7">{{ Request.RefNo }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Quantity:</div>
          <div class="col-xs-7">
            {{ Request.StringQuantity }} {{ Request.UnitName }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Price per Unit:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringUnitPrice }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Total Price:</div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname }} {{ Request.StringAmount }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Contract Date:</div>
          <div class="col-xs-7">
            {{ Timestrap(Request.ApplicationDate) }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Value Date:</div>
          <div class="col-xs-7">{{ DateFromat(Request.ValueDate, true) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Deliverer of Metal:
          </div>
          <div class="col-xs-7">INMAINV-PT01</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Certificate of Title:
          </div>
          <div class="col-xs-7">{{ Request.RefNo }} Holding Certificate</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">Location:</div>
          <div class="col-xs-7">{{ Request.SupplierLocation }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-5" style="font-weight: 600">
            Commodity Adminstration Fee:
          </div>
          <div class="col-xs-7">
            {{ Request.CurrencyShortname == "SAR" ? "SAR" : "USD" }}&nbsp;{{
              Request.CurrencyShortname == "SAR"
                ? Request.SARCommission.toFixed(2)
                : Request.USDCommission.toFixed(2)
            }}
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="text-align: justify">
            <p>
              Once legal title to the Commodity identified above has been
              transferred to you, the Commodity will be held in storage by us to
              your order pending receipt of further instructions from you and a
              copy of the relevant holding certificate was sent to you and no
              transaction whatsoever shall be carried using the Commodity
              following its sale to you and prior to any disposal by you to a
              third party.
            </p>
            <p style="margin-top: 15px">
              We, Fajr Investment Advisory B.S.C. (c) ,executed this Transaction
              as principal Please notify any discrepancies to us within 2
              Business Days. You will be deemed to have accepted the contents of
              this Confirmation if you fail to notify us of any discrepancies.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <br />For and on behalf of
            <br />
            <b>Fajr Investment Advisory B.S.C.(c)</b>
            <br />
          </div>
        </div>
      </div>
      <br />
      <p style="text-align: center; font-size: 10px; margin-bottom: -15px">
        <em style="font-size: 16px"
          >This is a computer generated document, issued by a secure platform
          and as such, does not require a signature.</em
        >
      </p>
      <hr style="border: 1px solid #b35900" />
      <p style="font-size: 14px; text-align: center; margin-top: -30px">
        <br />P.O.Box 10797 - Manama,Kingdom of Bahrain, Tel: +973 17 540600,
        www.fajr.com.bh C.R.-68481
      </p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-size: 18px;
}
</style>

  <script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapGetters({
      Request: "GETBUYREQUEST",
      AggrementDate: "GETAGGREMENTDATE",
    }),
  },
};
</script>
<style scopped>
tr td {
  border: 0;
}
.Details > tr > td:nth-child(odd) {
  width: 26%;
}
</style>
